import React from 'react';
import { connect } from 'react-redux';
import { Map } from 'immutable';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import ProductPrice from 'components/Product/price';
import FormattedModifierValue from 'components/FormattedModifierValue';
import ItemName from 'components/OrderReview/ItemName';
import ItemPrice from 'components/OrderReview/ItemPrice';
import { getModifierPrice } from 'selectors/browse';
import NotesIcon from 'components/Icons/NotesIcon';
import { groupModifiersForDisplay } from 'utils/modifierDisplay';

import messages from '../messages';
import { LineItem, LineItemFlex, Modifier, StyledPrice } from './styles';

const ProductLineItem = ({ item, getModifierPrice }) => (
  <LineItem>
    <LineItemFlex>
      <ItemName item={item} />
      <StyledPrice>
        <ItemPrice item={item} />
      </StyledPrice>
    </LineItemFlex>
    {item.get('modifiers') &&
      groupModifiersForDisplay(item.get('modifiers')).map((row, index) => (
        <Modifier key={index}>
          <LineItemFlex className="italic secondary-font">
            {row.modifierName && `${row.modifierName}: `}
            {row.segments.map((segment, i) => (
              <React.Fragment key={i}>
                {i > 0 && ' - '}
                <span className="lowercase">
                  {segment.quantity > 1 ? `${segment.quantity} x ` : ''}
                </span>
                <FormattedModifierValue value={segment.value} type={segment.type} />
              </React.Fragment>
            ))}
            <StyledPrice>
              {row.hasPriceAdjustment ? (
                <ProductPrice
                  price={row.values.reduce(
                    (sum, value) => sum + (getModifierPrice(value, item.get('tax_category_ids')) || 0),
                    0
                  )}
                />
              ) : (
                ''
              )}
            </StyledPrice>
          </LineItemFlex>
        </Modifier>
      ))}
    {(item.get('notes') || null) && (
      <div>
        <NotesIcon height="20px" />
        <FormattedMessage {...messages.has_notes} />
      </div>
    )}
  </LineItem>
);

ProductLineItem.propTypes = {
  item: PropTypes.instanceOf(Map).isRequired,
  getModifierPrice: PropTypes.func,
};

const mapStateToProps = state => ({
  getModifierPrice: (modifier, taxCategories) => getModifierPrice(state, modifier, taxCategories),
});

export default connect(mapStateToProps)(ProductLineItem);
